import { useEffect, useState, useRef } from "react";

export function useOnScreen<T extends Element>(
  options?: IntersectionObserverInit,
  once: boolean = true // se true, observa só uma vez
) {
  const ref = useRef<T | null>(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          if (once) observer.disconnect();
        } else {
          if (!once) setIsIntersecting(false);
        }
      },
      options
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref, options, once]);

  return [ref, isIntersecting] as const;
}
